import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { AppVersionService } from '../../services/app-version/app-version.service';

/** Indicador fijo y discreto con la versión del APK y de la web, visible en todas las pantallas. */
@Component({
  selector: 'app-version-badge',
  standalone: true,
  imports: [AsyncPipe, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (appVersion.info$ | async; as info) {
      <div
        class="version-badge"
        [ngClass]="info.updateState"
        [attr.title]="info.latestVersionName ? 'Última versión publicada: ' + info.latestVersionName : null"
      >
        <span>APK {{ info.apkVersionName || '—' }}@if (info.apkVersionCode != null) { ({{ info.apkVersionCode }})}</span>
        <span class="sep">·</span>
        <span>Web {{ appVersion.webVersionLabel() || 'dev' }}</span>
        @if (info.updateState === 'required' || info.updateState === 'optional') {
          <span class="sep">·</span>
          <span>Actualizar a {{ info.latestVersionName }}</span>
        }
      </div>
    }
  `,
  styles: [
    `
      .version-badge {
        position: fixed;
        left: 4px;
        bottom: 2px;
        z-index: 10000;
        padding: 1px 6px;
        border-radius: 8px;
        font-size: 10px;
        line-height: 14px;
        font-family: monospace;
        color: #3c4b5c;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0 0 0 1px rgba(60, 75, 92, 0.15);
        pointer-events: none;
        user-select: none;
        white-space: nowrap;
      }
      .sep {
        margin: 0 4px;
        opacity: 0.6;
      }
      .optional {
        color: #7a4f00;
        background: rgba(255, 236, 179, 0.9);
      }
      .required {
        color: #fff;
        background: rgba(198, 40, 40, 0.9);
      }
    `,
  ],
})
export class VersionBadgeComponent {
  constructor(public appVersion: AppVersionService) {}
}
